import React, { Component } from 'react';
import { Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
var _ = require('lodash');

export default class ProductCard extends React.Component {

    constructor(props) {
        super(props);

        this.findProductImageByid = this.findProductImageByid.bind(this);
    }

    findProductImageByid(id){
        var image = _.find(this.props.productImages, {id:id[0]});
        if(image != null && image != undefined) {
            return image.url;
        }
    }
    

    render() {
        //set language 
        if(this.props.language == "chi") {
            this.props.products.displayName = this.props.products.name_chi;
        } else { 
            this.props.products.displayName = this.props.products.name;
        }

        const brStyle = {
            minHeight: '800px',
            padding: '400 0 500 0'
        };

        const productImageStyle = {
            maxHeight: '168px',
            // width: '100%',
            display: 'block',
            margin: 'auto'
        }

        const cardFooterStyle = {
            borderTop: '0'
        }

        var productDetailsLink = "/product/" + this.props.products.name.split(' ').join('-') + "--" + this.props.products.idCode.split(' ').join('-');
    

        // Use the first image stored in database, find it and then use the "url" value
        var imageSrc = "";
        if(this.props.products.images === null || this.props.products.images === undefined  || this.props.products.images.length < 1){
            imageSrc = "/img/icons/no-image-available.png";
        } else {
            // console.log("------")
            // console.log(this.props.products.name + " , id: " +  this.props.products.id);
            // console.log(this.props.products.images);
            imageSrc = this.findProductImageByid(this.props.products.images);
            // console.log(imageSrc);
            // console.log(this.props.products);
        }
         
        return (
            <Col lg={4}>
                <div className="card mb-4 product-card overlay-hover">
                    {/*<!-- Hover content -->*/}
                    {/*<div className="overlay-hover-content overlay-op-7">*/}
                    {/*<a href="shop-cart.htm" className="btn btn-primary btn-block text-uppercase font-weight-bold mb-3 btn-lg"><i className="fa fa-envelope mr-2"></i> Add to Enquire</a>*/}
                    {/*<a href="#" className="text-white text-sm">View Product Details</a>*/}
                    {/*<a href="#" className="text-white text-sm">Add to Wishlist</a>*/}

                    {/*</div>*/}
                    {/*<!-- Image & price content -->*/}
                    <div className="pos-relative">
                        <img style={productImageStyle} className="card-img-top img-fluid" src={imageSrc} alt="" />
                    </div>
                    {/*<!-- Content -->*/}
                    <div className="card-block">
                        <small className="text-muted text-uppercase"><span className="text-primary">{this.props.products.code}</span></small>
                        <h4 className="card-title">{this.props.products.displayName}</h4>
                        <p className="card-text">{this.props.products.description}</p>
                    </div>
                    <div className="card-footer" style={cardFooterStyle}>
                        <small>
                            <Link className="text-primary pull-right" to={productDetailsLink}>{this.props.getTranslatedText("ViewProductDetails")}</Link>
                        </small>
                    </div>
                </div>
            </Col>
        )
    }
}



// WEBPACK FOOTER //
// ./src/component/ProductCard.js